<template>
    <div class="stat-table">
        <h3>Pending Approvals</h3>
        <table>
            <thead>
                <tr>
                    <th class="header">Name</th>
                    <th class="header">Speciality</th>
                    <th class="header third">Actions</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(doctor, index) in limitedItems" :key="index">
                    <td class="first">{{ doctor.fullName }}</td>
                    <td class="second">{{ doctor.speciality }}</td>
                    <td class="third">
                        <button
                            class="btn btn-link p-0 text-success"
                            style="text-decoration: none"
                            @click="onApprove(doctor.id)"
                        >
                            &#10003;
                        </button>
                        <button
                            class="btn btn-link p-0 text-danger ml-2"
                            style="text-decoration: none"
                            @click="onReject(doctor.id)"
                        >
                            &#10005;
                        </button>
                    </td>
                </tr>
            </tbody>
        </table>
        <div v-if="showAllVisible" class="show-all" @click="openModal">
            Show all
        </div>

        <div v-if="showModal" class="modal-overlay" @click.self="closeModal">
            <div class="modal-content">
                <div class="modal-header">
                    <h3>All Pending Approvals</h3>
                    <button class="modal-close" @click="closeModal">×</button>
                </div>
                <div class="modal-body">
                    <table>
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Speciality</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                v-for="doctor in pendingDoctors"
                                :key="doctor.id"
                            >
                                <td>{{ doctor.fullName }}</td>
                                <td>{{ doctor.speciality }}</td>
                                <td>
                                    <button
                                        class="btn btn-link p-0 text-success"
                                        style="text-decoration: none"
                                        @click="onApprove(doctor.id)"
                                    >
                                        &#10003;
                                    </button>
                                    <button
                                        class="btn btn-link p-0 text-danger ml-2"
                                        style="text-decoration: none"
                                        @click="onReject(doctor.id)"
                                    >
                                        &#10005;
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
    props: {
        data: {
            type: Array,
            required: true,
            default: () => []
        }
    },

    data() {
        return {
            maxItems: 5,
            pendingDoctors: [],
            showModal: false
        };
    },

    watch: {
        data(value) {
            this.pendingDoctors = [...value];
        }
    },

    computed: {
        limitedItems() {
            return this.pendingDoctors.slice(0, this.maxItems);
        },

        showAllVisible() {
            return this.pendingDoctors.length > this.maxItems;
        }
    },

    methods: {
        ...mapActions({
            approveDoctor: 'doctors/approve',
            deleteDoctor: 'doctors/destroy'
        }),

        async onApprove(doctorId) {
            try {
                await this.approveDoctor({ id: doctorId });

                this.removeDoctorFromList(doctorId);

                this.$bvToast.toast('Doctor approved!', {
                    title: 'Success!',
                    variant: 'success',
                    solid: true
                });
            } catch (err) {
                console.error(err);
                this.$bvToast.toast('Something went wrong!', {
                    title: 'Error!',
                    variant: 'danger',
                    solid: true
                });
            }
        },

        async onReject(doctorId) {
            try {
                await this.deleteDoctor({ id: doctorId });

                this.removeDoctorFromList(doctorId);

                this.$bvToast.toast('Doctor deleted!', {
                    title: 'Success!',
                    variant: 'success',
                    solid: true
                });
            } catch (err) {
                console.error(err);
                this.$bvToast.toast('Something went wrong!', {
                    title: 'Error!',
                    variant: 'danger',
                    solid: true
                });
            }
        },

        removeDoctorFromList(doctorId) {
            this.pendingDoctors = this.pendingDoctors.filter(
                doctor => doctor.id !== doctorId
            );
        },

        openModal() {
            this.showModal = true;
            document.body.style.overflow = 'hidden';
        },

        closeModal() {
            this.showModal = false;
            document.body.style.overflow = '';
        }
    }
};
</script>
